import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import AuthService from '@/shared/services/AuthService';
import { LegalEntityQueryKey } from './queryKey';
export var useGetLegalEntityNames = function () {
    var intl = useIntl();
    return useQuery([LegalEntityQueryKey.LegalEntityNames], function () { return api.base.get('/api/legalentity/names').then(function (res) { return res.data; }); }, {
        enabled: AuthService.hasFeature('TenantMoore'),
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
